// extracted by mini-css-extract-plugin
export var fadeInOut = "_2q-3";
export var icon = "_2q-4";
export var savedIndicator = "_2q-2";
export var savingIndicator = "_2q-0";
export var spin = "_2q-1";